<template>
	<DjBox>
		<img class="max-w-full w-full rounded-t-2xl overflow-hidden" :alt="title" :src="photoUrl" />
		<h3 class="m-3 md:m-6 text-lg md:text-xl font-medium">{{ title }}</h3>
		<p class="mx-3 md:mx-6 mb-3 md:mb-6">
			<strong class="uppercase">{{ name }}</strong>
			-
			<span>{{ text }}</span>
		</p>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DjBox from "./DjBox.vue";

export default defineComponent({
	name: "DjBoxPhotoWithRte",
	components: {
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		photoUrl: {
			type: String,
			default: "",
			required: true,
		},
		name: {
			type: String,
			default: "",
			required: false,
		},
		text: {
			type: String,
			default: "",
			required: false,
		},
	},
});
</script>
